export const USER_PROFILE_LOAD_CONTENT = 'USER_PROFILE_LOAD_CONTENT'
export const USER_PROFILE_CONTENT_LOADED = 'USER_PROFILE_CONTENT_LOADED'

export const USER_PROFILE_SHOW_LOADER = 'USER_PROFILE_SHOW_LOADER'
export const USER_PROFILE_HIDE_LOADER = 'USER_PROFILE_HIDE_LOADER'

export const LOCALE_PREFIX = 'components.Dialog.components.UserProfile.components.Content.components.Loader'
